import { useSelector } from "react-redux";
import StatCard from "../../component/Dashboard/StatCard";
import {
  Calendar,
  MessageSquare,
  TrendingUp,
  Users,
  FileText,
  CreditCard,
} from "lucide-react";

const StatsCardComponent = () => {
  const dashboardData = useSelector((state) => state.Dashboard.lists);
  const statsData = [
    {
      title: "Total Interview Credits",
      value: dashboardData?.totalCredits || 0,
      icon: <CreditCard className="w-5 h-5" />,
      color: "blue",
    },
    {
      title: "Credits Utilized",
      value: dashboardData?.utilizedCredits || 0,
      icon: <TrendingUp className="w-5 h-5" />,
      color: "green",
    },
    {
      title: "Credits Remaining",
      value: dashboardData?.remainingCredits || 0,
      icon: <Calendar className="w-5 h-5" />,
      color: "orange",
    },
    {
      title: "Valid Until",
      value: dashboardData?.validTill || "NA",
      icon: <Calendar className="w-5 h-5" />,
      color: "purple",
    },
    {
      title: "Total Candidates",
      value: dashboardData?.interview?.total || 0,
      icon: <Users className="w-5 h-5" />,
      color: "blue",
      subtitle: "+12% from last month",
    },
    {
      title: "Contacted",
      value:
        dashboardData?.interview?.inProgress ||
        0 + dashboardData?.interview?.completed ||
        0 + dashboardData?.interview?.followUp ||
        0 + dashboardData?.interview?.noResponse ||
        0,
      icon: <MessageSquare className="w-5 h-5" />,
      color: "green",
      subtitle: "+8% from last month",
    },
    {
      title: "Responses",
      value: dashboardData?.interview?.completed || 0,
      icon: <TrendingUp className="w-5 h-5" />,
      color: "green",
      subtitle: "+15% from last month",
    },
    {
      title: "Active Positions",
      value: dashboardData?.position?.active || 0,
      icon: <FileText className="w-5 h-5" />,
      color: "orange",
      subtitle: "2 new this month",
    },
  ];
  return (
    <div className="row g-2 mb-2">
      {statsData.map((stat, index) => (
        <div key={index} className="col-12 col-md-6 col-lg-3">
          <StatCard
            title={stat.title}
            value={stat.value}
            subtitle={stat.subtitle}
            trend={stat.trend}
            icon={stat.icon}
            color={stat.color}
          />
        </div>
      ))}
    </div>
  );
};

export default StatsCardComponent;
